<mat-icon
	[ngClass]="{ 'tooltip-icon-float-right': floatRight }"
	class="font-size-9 tooltip-break front-main-1 cursor-pointer mt-n1 font-demi-bold tooltip-icon d-flex justify-content-center align-items-center"
	[matTooltip]="tooltip"
	matTooltipClass="tooltip-break"
>
	help
</mat-icon>
